import { useContext } from "react"
import { useT } from "react-polyglot-hooks"
import kebabCase from "lodash/kebabCase"
import { RentingContext } from "scenes/RentingScene/RentingContext"
import useFilteredOptions from "hooks/useFilteredOptions"
import * as PropTypes from "prop-types"
import DropdownSelector from "../DropdownSelector"

export default function BrandSelector(props) {
  const t = useT()
  const { field } = props
  const { brands } = useContext(RentingContext)
  const options = useFilteredOptions(field, () =>
    Object.keys(brands).map(brand => ({ value: kebabCase(brand), label: `${brand} (${brands[brand]})` }))
  )

  return (
    <DropdownSelector
      options={options}
      placeholder={t("renting.filter.brand_placeholder")}
      multiple
      dynamic
      {...props}
    />
  )
}

BrandSelector.propTypes = {
  field: PropTypes.string.isRequired
}
